import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentFacilityCarePath} from './PropertyPaths/accidentFacilityCarePath';

export const IntensiveCareUnitConfinement = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedProduct} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentFacilityCarePath(selectedPlan?.planIndex ?? 0, 0);

  const productCd = selectedProduct?.code ?? '';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'icu-row-1'},
      items: [
        {
          key: propertyPaths.intensiveCareUnitConfinementDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.intensiveCareUnitConfinementDetails.incurralPeriod)}
              id={propertyPaths.intensiveCareUnitConfinementDetails.incurralPeriod}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.intensiveCareUnitConfinementDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(
                propertyPaths.intensiveCareUnitConfinementDetails.customizeBenefitAmount
              )}
              id={propertyPaths.intensiveCareUnitConfinementDetails.customizeBenefitAmount}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'icu-row-2'},
      items: [
        {
          key: propertyPaths.intensiveCareUnitConfinementDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount (Per Day)"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.intensiveCareUnitConfinementDetails.benefitAmount)
              )}
              disabled
              id={propertyPaths.intensiveCareUnitConfinementDetails.benefitAmount}
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.intensiveCareUnitConfinementDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Number of Days per Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.intensiveCareUnitConfinementDetails.maxBenefitNumber)}
              id={propertyPaths.intensiveCareUnitConfinementDetails.maxBenefitNumber}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'icu-row-3'},
      items: [
        {
          key: propertyPaths.intensiveCareUnitConfinementDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={`${productCd}IntensiveCareUnitConfinementBenefit.timePeriodCd`}
              label="Time Period"
              disabled
              value={getQuoteFieldValue<number>(propertyPaths.intensiveCareUnitConfinementDetails.timePeriodCd)}
              id={propertyPaths.intensiveCareUnitConfinementDetails.timePeriodCd}
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
